import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-cap',
  templateUrl: './cap.component.html',
  styleUrls: ['./cap.component.scss'],
  standalone: false
})
export class CAPComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'pillars', label: 'CAP Pillars', icon: 'bx-columns' },
    { id: 'lifecycle', label: 'Lifecycle', icon: 'bx-cycle' },
    { id: 'engagement', label: 'Engagement Model', icon: 'bx-heart' },
    { id: 'value', label: 'Business Value', icon: 'bx-line-chart' },
  ];

  capPillars = [
    { icon: 'bx-headphone', title: 'Support Layer', desc: 'Robust B2C L1 and B2B L2 support infrastructure for seamless onboarding and issue resolution.' },
    { icon: 'bx-code-block', title: 'SDK-Driven Integration', desc: 'Connects customer experiences, applications, and OEM digital touchpoints through a unified integration layer.' },
    { icon: 'bx-heart', title: 'Customer Engagement & Loyalty', desc: 'Motivates users to drive safer, stay engaged, and return to OEM digital ecosystems more often.' },
    { icon: 'bx-line-chart', title: 'Tracking & Analytics', desc: 'Tracks adoption, behavior, vehicle usage, and app engagement with connected-vehicle lifecycle visibility.' },
    { icon: 'bx-dollar-circle', title: 'Monetization', desc: 'Unlocks new OEM revenue opportunities through ecosystem partners and premium mobility services.' },
    { icon: 'bx-briefcase-alt-2', title: 'Domain Expertise & Lifecycle Management', desc: 'Backed by specialized ISM and FSM expertise to improve lifecycle outcomes across connected mobility programs.' },
  ];

  lifecycleStages = [
    { stage: 'Onboarding', icon: 'bx-user-plus', desc: 'Supports first-use activation, guidance, and onboarding journeys across connected mobility products.' },
    { stage: 'Adoption', icon: 'bx-trending-up', desc: 'Promotes deeper feature usage and habitual engagement through contextual programs and product nudges.' },
    { stage: 'Engagement', icon: 'bx-message-dots', desc: 'Keeps users connected through loyalty, rewards, and personalized digital experiences.' },
    { stage: 'Analytics', icon: 'bx-pie-chart-alt-2', desc: 'Tracks behavior, feature adoption, and lifecycle performance with connected-vehicle domain context.' },
    { stage: 'Monetization', icon: 'bx-store-alt', desc: 'Enables OEMs to monetize services across mobility, lifestyle, and vehicle ownership layers.' },
    { stage: 'Lifecycle Management', icon: 'bx-refresh', desc: 'Connects every stage from onboarding to retention into one coordinated customer program.' },
  ];

  engagementModel = [
    {
      title: 'Support Layer',
      icon: 'bx-support',
      desc: 'Ensures onboarding, issue resolution, and customer assistance are built into the lifecycle from day one.'
    },
    {
      title: 'Customer Engagement',
      icon: 'bx-gift',
      desc: 'Combines loyalty, rewards, and contextual engagement to create repeat interactions and sustained usage.'
    },
    {
      title: 'Tracking & Analytics',
      icon: 'bx-bar-chart-alt-2',
      desc: 'Measures adoption, customer behavior, vehicle usage, and app activity to improve program performance.'
    },
    {
      title: 'OEM Monetization',
      icon: 'bx-rupee',
      desc: 'Supports monetization through connected partners, curated services, and ecosystem-led revenue streams.'
    },
  ];

  businessValue = [
    'Unified engagement framework across onboarding, adoption, analytics, and monetization.',
    'Meaningful, personalized user journeys throughout the vehicle and digital service lifecycle.',
    'Improved OEM retention, engagement performance, and monetization opportunities.',
    'Operational support from teams with deep connected-vehicle lifecycle expertise.',
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
